import { render, staticRenderFns } from "./management.vue?vue&type=template&id=0afaff88&scoped=true&"
var script = {}
import style0 from "./management.vue?vue&type=style&index=0&id=0afaff88&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0afaff88",
  null
  
)

export default component.exports